'use client';

import { useEffect } from 'react';

const ZOOM_LOCK = 'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover';

// iOS Safari auto-zooms when a form field with computed font-size < 16px is
// focused, and won't zoom back out on blur. Setting the page meta content to
// also bound `maximum-scale=1` while a field is focused prevents the zoom-in;
// reverting on blur restores pinch-zoom everywhere else. `initial-scale=1`
// stays in both states so iOS resets the scale when we flip back.
export function IosZoomGuard() {
  useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    if (!meta) return;
    const original = meta.getAttribute('content') ?? '';

    const isFormField = (el: EventTarget | null) => {
      if (!(el instanceof HTMLElement)) return false;
      if (el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement) return true;
      if (el instanceof HTMLInputElement) {
        const t = el.type;
        return t !== 'checkbox' && t !== 'radio' && t !== 'range' && t !== 'button' && t !== 'submit' && t !== 'reset' && t !== 'file' && t !== 'color';
      }
      return false;
    };

    const onFocusIn = (e: FocusEvent) => {
      if (!isFormField(e.target)) return;
      meta.setAttribute('content', ZOOM_LOCK);
    };
    const onFocusOut = (e: FocusEvent) => {
      if (!isFormField(e.target)) return;
      meta.setAttribute('content', original);
    };

    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('focusout', onFocusOut, true);
    return () => {
      document.removeEventListener('focusin', onFocusIn, true);
      document.removeEventListener('focusout', onFocusOut, true);
      meta.setAttribute('content', original);
    };
  }, []);

  return null;
}
